import Vue from 'vue';
import App from './app';

import moment from 'moment';

export default class Page extends Vue {
    get app(): App {
        let cmp: Vue = this;
        while (cmp) {
            if (cmp instanceof App) return cmp;
            cmp = cmp.$parent;
        }
        return cmp as App;
    }

    _(
        tgt: string | { [lang: string]: string },
        ...vars: (string | number)[]
    ): string {
        return this.app?.getLocaleText(tgt, ...vars) || '';
    }

    formatStayDate(date: string): string {
        const m = moment(date, 'YYYY-MM-DD HH:mm');
        return this.app.display_time_of_stay_dates
            ? m.format('YYYY/MM/DD HH:mm')
            : m.format('YYYY/MM/DD');
    }
}
